import { render, staticRenderFns } from "./EditarUnidade.vue?vue&type=template&id=0ebc6d8f&scoped=true"
import script from "./EditarUnidade.vue?vue&type=script&lang=js"
export * from "./EditarUnidade.vue?vue&type=script&lang=js"
import style0 from "./EditarUnidade.vue?vue&type=style&index=0&id=0ebc6d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc6d8f",
  null
  
)

export default component.exports